import React, { useState, useMemo } from "react";
import {
  Button,
  Paper
} from "@material-ui/core";
import { useTranslation } from "@/langs/useTranslation";
import CMSContentSelector from "@/components/FormFields/CMSContentSelector";
import { IconTrash } from "@/components/Icon";

const ContentPicker = ({
  handleChange,
  name,
  value,
  readonly,
  type = ""
}) => {
  const [open, setOpen] = useState(false)
  const { t } = useTranslation();


  const onConfirm = data => {
    const v = data[0]
    handleChange({
      target: {
        name,
        value: {
          resourceId: v.id,
          s3Path: v.s3Path,
          name: v.name
        }
      }
    })
  }

  const handleDelete = v => {
    // 3.11todo 删除
    handleChange({
      target: {
        name,
        value: {}
      }
    })
  }

  return (
    <>
      <Button color="primary" variant="outlined" onClick={() => setOpen(true)} disabled={readonly}>
        {
          t({ defaultMessage: "选择档案" })
        }
      </Button>
      {!!value && !!value.resourceId && (
        <Paper elevation={0} style={{ borderRadius: 6, backgroundColor: "#F8F9FC", marginTop: 16 }}>
          <div style={{ display: "flex" }}>
            <div style={{ color: "#00AFC6" }}>{value.name}</div>
            {!readonly && (
              <IconTrash style={{ marginLeft: "auto" }} color="red" onClick={() => handleDelete(value)} />
            )}
          </div>
        </Paper>
      )}
      <CMSContentSelector
        open={open}
        onClose={() => setOpen(false)}
        status={3}
        onConfirm={onConfirm}
        type={type}
        single
        selectedIds={value? value.id: ""}
        selectedDisable={false}
      />
    </>
  )
}

export default ContentPicker